import * as _ from 'lodash'
import { defineComponent, PropType } from 'vue'
import { faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Container } from '@skinsoft/types'
import { containerSelectors, locationSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { EntityFeaturedCard, LocalizedString } from '@skinsoft/ui'
import { toFeatured$ } from '../../serializer/featured'
import { DELETE_CARD } from '@skinsoft/events'

const MONGO_ID_REGEX = /^[a-f\d]{24}$/i

export const ContainerFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
        sLocalizedString: LocalizedString,
    },
    props: {
        featured: {
            type: Object as PropType<Container>,
            required: true,
        },
    },
    template: require('./container-featured-card.html'),
    data() {
        return {
            serializer: toFeatured$,
            locationPath: '',
            futureLocationPath: '',
            isBeingDeleted: false,
            deleting: false,
            checkIcon: faCheck,
            crossIcon: faTimes,
            circleNotchIcon: faCircleNotch,
        }
    },
    mounted() {
        this.fillLocation()
    },
    methods: {
        fillLocation() {
            this.futureLocationPath = containerSelectors.futureLocation(this.featured, this.getAppLocale())
            this.locationPath = containerSelectors.location(this.featured, this.getAppLocale())
            if(this.locationPath?.match(MONGO_ID_REGEX)) {
                this.$locationDataStore.fetchOne(this.locationPath).subscribe(location => {
                    this.locationPath = locationSelectors.fullPath(location, this.getAppLocale())
                })
            }
        },

        deleteContainer() {
            if(this.featured?.id) {
                this.deleting = true
                this.$emit(DELETE_CARD, this.featured.id)
            }
        },
    },
    watch: {
        featured() {
            this.isBeingDeleted = false
            this.deleting = false
            this.fillLocation()
        },
    },
})
